module.exports = {"id":"225719","name":"Kelechi Iheanacho","rating":"75","photo":"./data/images/photos/0/225719.png","club":{"name":"Leicester City","logo":"./data/images/clubs/LeicesterCity.png"},"positions":["BU","ATT"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/KelechiIheanacho0.json
// module id = 2312
// module chunks = 0